import { useEffect } from "react";
import Footer from "../../reusableUi/Footer";
import Hero from "./components/Hero";
import Main from "./components/Main";

export default function Home() {
  useEffect(() => {
    // Title
    document.title = "Chicago Plumbing Services | 24/7 Emergency Plumber";

    // Meta description
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "Licensed Chicago plumbers providing emergency plumbing, drain cleaning, leak repair, and water heater repair.",
      );
    }
  }, []);
  return (
    <div className="space-y-16">
      <Hero />
      <Main />
      <Footer />
    </div>
  );
}
